var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShape43(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.999,
    height: 20,
    viewBox: "0 0 19.999 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape_43",
    "data-name": "Shape 43",
    d: "M1314.069,1353.927A10,10,0,1,0,1317,1361,10,10,0,0,0,1314.069,1353.927Zm-1.925,11h0v0l-.507.5a2.664,2.664,0,0,1-2.517.72,8.863,8.863,0,0,1-2.573-1.153,12.323,12.323,0,0,1-3.547-3.477,9.342,9.342,0,0,1-1.14-2.307,2.667,2.667,0,0,1,.667-2.723l.593-.594a.424.424,0,0,1,.6,0h0l1.873,1.874a.424.424,0,0,1,0,.6h0l-1.1,1.1a.9.9,0,0,0-.093,1.167,13.135,13.135,0,0,0,3.05,2.993.9.9,0,0,0,1.153-.1l1.063-1.08a.423.423,0,0,1,.6,0h0l1.877,1.88A.423.423,0,0,1,1312.144,1364.929Z",
    transform: "translate(-1297 -1351)",
    fill: "#626262",
    opacity: 0.8
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape43);
export default __webpack_public_path__ + "static/media/Shape 43.dc02224ff592eb720ded74d4b833a47f.svg";
export { ForwardRef as ReactComponent };